<template>
  <div>

    <h5>
      {{ $t("account.preferences.language") }}
    </h5>
    <v-alert
      color="blue"
      text
      type="info"
    >{{ $t("account.preferences.language_info") }}</v-alert>


    <div class="margin-top-50">
      <v-btn-toggle v-model="toggle_exclusive" mandatory tile>
        <v-btn
            v-for="entry in languages"
            :key="entry.language"
            @click="changeLocale(entry.language)"
        >
          {{ $t(entry.title) }}
        </v-btn>
      </v-btn-toggle>
    </div>

    <h5>
      {{ $t("account.preferences.treatment") }}
    </h5>
    <v-alert
      color="blue"
      text
      type="info"
    >{{ $t("account.preferences.treatment_info") }}</v-alert>


    <div class="mt-8">
      <v-btn-toggle v-model="toggle_exclusive_2" mandatory tile>
        <v-btn
            v-for="entry in treatments"
            :key="entry.treatment"
            @click="changeTreatment(entry.treatment)"
        >
          {{ $t(entry.title) }}
        </v-btn>
      </v-btn-toggle>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "locale-changer",

  data() {
    return {
      languages: [
        {index: 0, language: "gl", title: "language.galician"},
        {index: 1, language: "es", title: "language.spanish"},
        {index: 2, language: "en", title: "language.english"}


      ],
      treatments: [
        {index: 0, treatment: "male", title: "treatment.male"},
        {index: 1, treatment: "female", title: "treatment.female"},
        {index: 2, treatment: "neutral", title: "treatment.neutro"}
      ],
      toggle_exclusive: 1,
      toggle_exclusive_2: 1

    };
  },

  created() {
    this.selectLanguageButton();
    this.selectTreatmentButton();
  },

  methods: {
    selectLanguageButton() {
      this.languages.map(lan => {
        if (lan.language === this.$i18n.locale) {
          this.toggle_exclusive = lan.index;
        }
      });
    },

    selectTreatmentButton() {
      let path =
          this.$store.state.endpoint + "/publicProfile/" + this.getUser.person;
      axios
          .get(path)
          .then(response => {
            this.treatments.map(lan => {
              if (lan.treatment === response.data.treatment) {
                this.toggle_exclusive_2 = lan.index;
              }
            });
          });
    },

    changeLocale(locale) {
      let path =
          this.$store.state.endpoint +
          "/publicProfile/language/" +
          this.getUser.person;
      axios
          .patch(path, {preferred_language: locale})
          .then(response => {
            this.$i18n.locale = locale;
            this.$store.dispatch("setLanguage", locale);
            this.$store.commit("alert", {
              color: "success",
              text: this.$t('language.info')
            });
          })
          .catch(error => {
            console.log(error);
            console.log(error.response.data);
            this.$store.commit("alert", {
              color: "error",
              text: this.$t("error.form.saving", [this.$t("error.form.types.preferred_language")])
            });
          });
    },
    changeTreatment(treatment) {
      let path =
          this.$store.state.endpoint +
          "/publicProfile/treatment/" +
          this.getUser.person;
      axios
          .patch(path, {treatment: treatment})
          .then(response => {
            this.$store.commit("alert", {
              color: "success",
              text: this.$t('treatment.info')
            });
          })
          .catch(error => {
            console.log(error.response.data);
            this.$store.commit("alert", {
              color: "error",
              text: this.$t("error.form.saving", [this.$t("error.form.types.treatment")])
            });
          });
    }
  }
};
</script>

<style scoped>
@media(max-width:699px){
  .v-btn-toggle {
    flex-direction: column;
  }
}
</style>
